/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Fair_Goat_AidInputs */

const en_flat_fair_goat_aid = /** @type {(inputs: Flat_Fair_Goat_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lastname`)
};

const de_flat_fair_goat_aid = /** @type {(inputs: Flat_Fair_Goat_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Lastname" |
*
* @param {Flat_Fair_Goat_AidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_fair_goat_aid = /** @type {((inputs?: Flat_Fair_Goat_AidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Fair_Goat_AidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_fair_goat_aid(inputs)
	return de_flat_fair_goat_aid(inputs)
});